/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-10-17 10:48:30
 * @FilePath: /vue_huaqiang/src/router/modules/financial-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const financialManagementRoutes: RouteConfig[] = [
  {
    path: "/financial",
    component: Layout,
    name: "FinancialManagement",
    meta: {
      title: "financialManagement",
      icon: "el-icon-s-finance",
      alwaysShow: true,
    },
    children: [
      {
        path: "hq-packing-list-audit",
        component: () =>
          import(
            "@/views/financial-management/HqPackingListAuditManagement.vue"
          ),
        name: "HqPackingListAuditManagement",
        meta: {
          title: "packingListAuditManagement",
        },
      },
      {
        path: "/supplierPaymentManagement",
        name: "supplierPaymentManagement",
        // redirect: "supplierPaymentManagementCW",
        meta: { title: "supplierPaymentManagementCW" },
        component: () =>
          import(
            "@/views-oms/financial-reconciliation-management/supplier-payment/index.vue"
          ),
      },
      {
        path: "/viewAllPurchaseOrders",
        name: "viewAllPurchaseOrders",
        // redirect: "viewAllPurchaseOrdersCW",
        meta: { title: "viewAllPurchaseOrdersCW" },
        component: () =>
          import("@/views-oms/purchase-order-management/order/all/index.vue"),
      },
      {
        // 收汇单管理
        path: "/collectionManagement",
        component: () => import("@/views-oms/collection-management/index.vue"),
        name: "collectionManagement",
        meta: { title: "collectionManagement" },
      },
      {
        // 客人清账管理
        path: "/settle-account-management",
        name: "settleAccountManagement",
        component: () =>
          import(
            "@/views-oms/collection-management/settle-account-management.vue"
          ),
        meta: { title: "settleAccountManagement" },
      },
      {
        path: "booking-orders",
        component: () =>
          import(
            "@/views/financial-management/FinancialBookingOrderManagement.vue"
          ),
        name: "FinancialBookingOrderManagement",
        meta: { title: "financialBookingOrderManagement" },
      },
      {
        path: "factory-billing",
        component: () =>
          import("@/views/financial-management/FactoryInvoiceManagement.vue"),
        name: "FactoryInvoiceManagement",
        meta: { title: "FactoryInvoiceManagement" },
      },
      {
        path: ":type/:parentId/packing-list/:hqPackingListId",
        name: "HqPackingListDetail",
        component: () =>
          import("@/views/inbound-management/HqPackingListDetail.vue"),
        meta: { title: "hqPackingListDetail", hidden: true },
      },
      {
        path: "customerCollectionManagement",
        component: () =>
          import("@/views-oms/collection-management/temp/temp.vue"),
        name: "customerCollectionManagement",
        meta: { title: "customerCollectionManagement" },
        children: [
          {
            // 收汇单管理
            path: "/collectionManagement",
            component: () =>
              import("@/views-oms/collection-management/index.vue"),
            name: "collectionManagement",
            meta: { title: "collectionManagement" },
          },
          {
            // 客人清账管理
            path: "/settle-account-management",
            name: "settleAccountManagement",
            component: () =>
              import(
                "@/views-oms/collection-management/settle-account-management.vue"
              ),
            meta: { title: "settleAccountManagement" },
          },
          {
            // 报关合同号&IV清账
            path: "/iv-settle-account",
            name: "ivSettleAccount",
            component: () =>
              import("@/views-oms/collection-management/iv-settle-account.vue"),
            meta: { title: "ivSettleAccount", hidden: true },
          },
        ],
      },
      {
        path: "/createPaymentOrder",
        name: "createPaymentOrder",
        meta: {
          title: "createPaymentOrder",
          hidden: true,
          activeMenu: "/supplierPaymentManagement",
        },
        component: () =>
          import(
            "@/views-oms/financial-reconciliation-management/supplier-payment/create-payment/index.vue"
          ),
      },
      {
        path: "invoiceBookingOrder",
        component: () =>
            import(
                "@/views/invoiceBookingOrder/index.vue"
                ),
        name: "invoiceBookingOrder",
        meta: {
          title: "invoiceBookingOrder",
        },
      },
      {
        path: "invoiceBookingOrder/:id",
        name: "invoiceBookingOrderDetail",
        meta: {
          title: "invoiceBookingOrderDetail",
          hidden: true,
          activeMenu: "/financial/invoiceBookingOrder",
        },
        component: () =>
            import("@/views/invoiceBookingOrder/detail.vue"),
      },
      {
        path: "/invoice",
        component: () =>
            import("@/views/invoice/index.vue"),
        name: "invoice",
        meta: {
          title: "invoice",
        },
      },
      // 查看付款单详情
      // {
      //   path: "/paymentOrderDetails",
      //   name: "paymentOrderDetails",
      //   meta: { title: "paymentOrderDetails" ,hidden: true, activeMenu: "/supplierPaymentManagement"},
      //   component: () =>
      //       import("@/views-oms/financial-reconciliation-management/supplier-payment/order-details/index.vue")
      // }
    ],
  },
];

export default financialManagementRoutes;
